// extracted by mini-css-extract-plugin
module.exports = {"title-section":"_2xpx8J-Rov","titleSection":"_2xpx8J-Rov","tabs":"omjnfU9KmB"};
    if(module.hot) {
      // 1614934732437
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  